
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, CircularProgress, FormControl, InputLabel, Select, MenuItem, Paper } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { ObtenerTipoJuicio } from '../../connections/catalogos/TipoJuicioConnection';
import { ObtenerTipoPrestaciones } from '../../connections/catalogos/TipoPrestacionConnection';
import { ActualizarTipoPrestacionJuicio, AgregarTipoPrestacionJuicio, TiposPrestacionesJuicio } from '../../connections/catalogos/TipoPrestacionJuicioConnection';

import { TipoJuicioProps } from '../../interfaces/catalogos/TipoJuicioInterface';
import { TipoPrestacionProps } from '../../interfaces/catalogos/TipoPrestacionInterface';
import { TipoPrestacionJuicioProps } from '../../interfaces/catalogos/TipoPrestacionJuicioInterface';

export const TipoPrestacionJuicioPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [idTipoPrestacionJuicio, setIdTipoPrestacionJuicio] = useState( 0 );
    const [tipoPrestacionJuicio, settipoPrestacionJuicio] = useState<TipoPrestacionJuicioProps[]>( [] );

    const [tipoPrestacion, setTipoPrestacion] = useState( 0 );
    const [tipoPrestacionArray, setTipoPrestacionArray] = useState<TipoPrestacionProps[]>( [] );

    const [tipoJuicio, setTipoJuicio] = useState( 0 );
    const [tipoJuicioArray, setTipoJuicioArray] = useState<TipoJuicioProps[]>( [] );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const [filtroTipoJuicio, setFiltroTipoJuicio] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( tipoPrestacionJuicio, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const ftj = filtroTipoJuicio.toLowerCase();
        return (
            ( filtro === '' || ( item.tipoPrestacion?.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroTipoJuicio === '' || ( item.tipoJuicio?.descripcion?.toLowerCase().includes( ftj ) ?? false ) )
        );
    });

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const tipoPrestacionJuicioselected = tipoPrestacionJuicio.find((elem) => elem.idTipoPrestacionJuicio === id);

        if (tipoPrestacionJuicioselected) {

            await ActualizarTipoPrestacionJuicio({ ...tipoPrestacionJuicioselected, activo: checked }).then(resp => {

                if (resp.idTipoPrestacionJuicio) {

                    var newArray = tipoPrestacionJuicio.map((elem) => {

                        if (elem.idTipoPrestacionJuicio === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    settipoPrestacionJuicio(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }

            });
        }

    }

    const handleGuardar = async () => {

        if (idTipoPrestacionJuicio !== 0) {

            const tipoPrestacionJuicioSelected = tipoPrestacionJuicio.find((elem) => elem.idTipoPrestacionJuicio === idTipoPrestacionJuicio);

            if ( tipoPrestacionJuicioSelected ) {

                setLoading( true );

                await ActualizarTipoPrestacionJuicio({ ...tipoPrestacionJuicioSelected, idTipoJuicio: tipoJuicio, idTipoPrestacion: tipoPrestacion }).then(resp => {

                    if ( resp.idTipoPrestacionJuicio ) {

                        setTimeout(() => {

                            var newArray = tipoPrestacionJuicio.map((elem) => {

                                if (elem.idTipoPrestacionJuicio === idTipoPrestacionJuicio) {
                                    elem.idTipoJuicio = tipoJuicio;
                                    elem.tipoJuicio = resp.tipoJuicio
                                    elem.idTipoPrestacion = tipoPrestacion;
                                    elem.tipoPrestacion = resp.tipoPrestacion
                                }

                                return elem;
                            });

                            settipoPrestacionJuicio(newArray);
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const tipoPrestacionJucioAdd: TipoPrestacionJuicioProps = {
                idTipoPrestacionJuicio: 0,
                idTipoPrestacion: tipoPrestacion,
                idTipoJuicio: tipoJuicio,
                activo: true,
            };

            setLoading( true );

            await AgregarTipoPrestacionJuicio(tipoPrestacionJucioAdd).then(resp => {

                if (resp.idTipoPrestacionJuicio) {

                    setTimeout(() => {

                        settipoPrestacionJuicio([...tipoPrestacionJuicio, resp]);
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el tipo de prestación por juicio correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            settipoPrestacionJuicio( [] );

            await TiposPrestacionesJuicio().then(resp => {

                setTimeout(() => {

                    settipoPrestacionJuicio(resp);
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setTipoPrestacionArray( [] );

            await ObtenerTipoPrestaciones().then(resp => {

                setTimeout(() => {

                    setTipoPrestacionArray(resp);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setTipoJuicioArray( [] );

            await ObtenerTipoJuicio().then(resp => {

                setTimeout(() => {

                    setTipoJuicioArray(resp);

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de prestación por juicio' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdTipoPrestacionJuicio( 0 );
                            setTipoJuicio( 0 );
                            setTipoPrestacion( 0 );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={ 2 }>

                <Grid size={{ xs: 12, md: 6 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por tipo de prestación'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>

                    <SearchTextField
                        value={ filtroTipoJuicio }
                        label='Buscar por tipo de juicio'
                        onChange={ ( value ) => {
                            setFiltroTipoJuicio( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%' }}> Tipo de prestación </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%' }}> Tipo de juicio </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltrada
                            )
                                .map(({ idTipoPrestacionJuicio, activo, idTipoJuicio, tipoJuicio, idTipoPrestacion, tipoPrestacion,  }) => (

                                    <TableRow key={ idTipoPrestacionJuicio } >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            {idTipoPrestacionJuicio}
                                        </TableCell>

                                        <TableCell>
                                            {tipoPrestacion?.descripcion}
                                        </TableCell>

                                        <TableCell>
                                            {tipoJuicio?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={ activo }
                                                onChange={ (e) => handleChangeChecked(e.target.checked, idTipoPrestacionJuicio) }
                                            />

                                            <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {

                                                    setIdTipoPrestacionJuicio( idTipoPrestacionJuicio );
                                                    setTipoJuicio( idTipoJuicio );
                                                    setTipoPrestacion( idTipoPrestacion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {dataFiltrada.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Tipo Prestación</InputLabel>

                                <Select
                                    label='Tipo Prestación'
                                    value={ tipoPrestacion }
                                    onChange={ (e) => setTipoPrestacion( parseInt(e.target.value.toString() ?? '0') ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoPrestacionArray.map((elem) => (
                                            <MenuItem key={ elem.idTipoPrestacion } value={ elem.idTipoPrestacion }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Tipo juicio</InputLabel>

                                <Select
                                    label='Tipo juicio'
                                    value={ tipoJuicio }
                                    onChange={ (e) => setTipoJuicio( parseInt(e.target.value.toString() ?? '0') ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoJuicioArray.map((elem) => (
                                            <MenuItem key={ elem.idTipoJuicio } value={ elem.idTipoJuicio }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); }}> Cancelar </Button>
                    <Button loading={ loading } disabled={ tipoJuicio === 0 || tipoPrestacion === 0 } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}